<template>
  <div class="ordersDetails">
    <div>
      <v-row class="titles-row" style="width:98% !important;margin-right:1rem !important;margin-left: 1rem !important">
        <v-col cols="12" md="3" class="text-center">
          <b> {{ $t("Product") }}</b>
        </v-col>
        <v-col cols="12" md="2" class="text-center">
          <b> {{ $t("Price") }}</b>
        </v-col>
        <v-col cols="12" md="2" class="text-center">
          <b> {{ $t("Quantity") }}</b>
        </v-col>

        <v-col cols="12" md="2" class="text-center">
          <b> {{ $t("TotalProductPrices") }}</b>
        </v-col>
        <v-col cols="12" md="3" class="text-center">
          <b> {{ $t("DelieveryFees") }}</b>
        </v-col>
      </v-row>
      <div
        class="Products-details-row"
        v-for="(item, index) in newCartItems"
        :key="index"
      >
        <p class="orange-color">{{ $t("proId") }} {{ index + 1 }}</p>
        <v-row
          class="px-3 details-row-style"
          v-for="(pro, index) in item.data"
          :key="index"
          style="border-top:#f1f1f1"
        >
        <div></div>
          <v-col cols="12" md="3">
            <div>
              <v-row>
                <v-col cols="12" md="6" class="remove-padding">
                  <div class="image-style">
                    <v-img :src="pro.thumb"></v-img>
                  </div>
                </v-col>
                <v-col 
                    cols="12" 
                    md="6" 
                    class="remove-padding product-data"
                    :style="(locale == 'ar') ? 'text-align:right !important' : 'text-align:left !important'">
                  <p 
                    :style="(locale == 'ar') ? 'margin-right: 0px !important' : 'margin-left: 10px !important'">
                    {{ pro.name }}
                  </p>
                  <p 
                    style="margin-top:-10px"
                    :style="(locale == 'ar') ? 'margin-right: 0px !important' : 'margin-left: 10px !important'"
                    class="main-color">
                    {{ pro.category_name }}
                  </p>
                  <v-btn
                    style="margin-top:-10px"
                    :style="(locale == 'ar') ? 'margin-right: -5px !important' : 'margin-left: 5px !important'"
                    class="delete-button remove-padding"
                    @click="removeFromCart(pro.id)"
                  >
                    <v-icon class="material-icons">
                      cancel
                    </v-icon>
                    {{ $t("Delete") }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <v-col cols="12" md="2">
            <div>
              <p class="orange-color">
                {{ pro.unit_price }} {{ $t("currency") }}
              </p>
            </div>
          </v-col>

          <v-col cols="12" md="2">
            <div>
              <template>
                <p class="quantity" style="min-width: 120px">
                  <span class="add-icon" @click="increaseQuantity(pro)">
                    <v-icon color="white"> add</v-icon>
                  </span>
                  <span class="grey--text quantity-value">
                    <input
                      v-model="pro.quantity"
                      type="number"
                      class="form-controls quantity-input"
                      min="1"
                    />
                  </span>
                  <span class="remove-icon" @click="decreaseQuantity(pro)">
                    <v-icon color="white">remove</v-icon>
                  </span>
                </p>
              </template>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div>
              <p class="orange-color">
                {{ pro.unit_price * pro.quantity }} {{ $t("currency") }}
              </p>
            </div>
          </v-col>

          <v-col cols="12" md="3" v-if="index == 0">
            <div>
              <div>
                <p class="orange-color">
                  {{ item.shipment_cost }} {{ $t("currency") }}
                </p>
                <p>
                  {{ $t("DeliveryDate") }}
                </p>
                <div class="main-color" style="margin-top:-15px;direction: rtl">
                    {{ item.dayFromTo }}
                    {{ $t("Days") }} 
                </div>
                    
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <br/><br/>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "NewOrderDetailsComponent",
  mixins: [validationMixin],

  props: {
    items: {
      type: Array
    },
    newCartItems: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selectedCountry: "",
      newShipment: false,
      addressValid: false,
      CartItems: this.$props.newCartItems,
      shippingObj: {
        address_id: 0,
        user_address: {
          address: "",
          user_city_id: ""
        }
      }
    };
  },
  methods: {
    getCartData() {
      this.$http
        .get(
          this.getApiUrl +
            "/market/cart?cartID=" +
            (localStorage.cartID && localStorage.cartID != undefined
              ? localStorage.cartID
              : ""),
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.cartItems = response.data.data.cartItems;
            this.subTotal = response.data.data.subTotal;
            this.totalQuantity = response.data.data.totalQuantity;
            this.totalItemsCount = this.cartItems.length;
          }
        });
    },
    removeFromCart(id) {
      if (confirm(this.$i18n.t("delete_cart_confirm_message"))) {
        this.$http
          .get(
            this.getApiUrl +
              "/market/cart/remove/" +
              id +
              "?cartID=" +
              (localStorage.cartID && localStorage.cartID != undefined
                ? localStorage.cartID
                : ""),
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                locale: localStorage.locale
              }
            }
          )
          .then(response => {
            if (response.data.status.error == false) {
              this.getCartData();
            }
            this.$emit("cartChanged");
          });
      }
    },
    increaseQuantity(item) {
      if (parseInt(item.quantity) <= parseInt(item.attributes.stock)) {
        item.quantity++;
        item.price = item.unit_price * item.quantity;
        this.$emit("updateCart");
        //  this.calculateSubtotal();
      } else {
        this.$refs.snack.sendErrorAlert(
          this.$i18n.t("Required quantity is not available")
        );
      }
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        item.quantity--;
        item.price = item.unit_price * item.quantity;
        this.$emit("updateCart");

        // this.calculateSubtotal();
      }
    },

    getCities() {
      this.$http
        .get(this.getApiUrl + "/market/cities/" + this.selectedCountry, {
          headers: {
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.cities = response.data.data;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.remove-padding {
  padding: 0px !important;
}
.Products-details-row {
  background-color: #fbfbfb;
  margin: 1rem;
  padding: 1rem;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 0px 10px 1px #eeeeee;

  .image-style {
    background-color: white !important;
    padding: 1rem;
    border: 1px solid #eeeeee;
  }
  .details-row-style {
    text-align: center;
  }
}
.quantity {
  .quantity-value {
    padding: 0 10px;
  }
  .add-icon,
  .remove-icon {
    display: inline-block;
    border: 1px solid #187e89;
    background-color: #13a8b1;
    color: #187e89 !important;
    border-radius: 5px;
    cursor: pointer;
  }
  .quantity-input {
    width: 40px !important;
    background-color: #fff;
    border: 1px solid #ffc382;
    text-align: center;
    color: #ffc382;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
}
.titles-row {
  padding-top: 1rem;
  margin-right: 5rem;
  border-bottom: 2px solid #ece8e8;
  padding-bottom: 1rem;
  margin-bottom: -13px;
  width: 91%;
}
button.delete-button.v-btn.v-btn--contained.theme--light.v-size--default {
  color: red;
  border: unset;
  background-color: transparent;
  box-shadow: unset !important;
}
.product-data {
  text-align: right;
  padding-right: 1rem !important;
}
.orange-color {
  color: #ffc382 !important
}
</style>
